import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "forget-password" }
const _hoisted_2 = { class: "forget-password-card" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "content"
}
const _hoisted_5 = { class: "content-item" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "content-item" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = {
  key: 1,
  class: "content"
}
const _hoisted_12 = {
  key: 2,
  class: "content"
}

import {
  checkResetPasswordIdApi,
  resetPasswordApi,
} from "@/api/manager/managerApi";
import { ResetPasswordParams } from "@/types/validator";
import { ElMessage } from "element-plus";
import { isArray, some, startsWith } from "lodash-es";
import { onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordView1',
  setup(__props) {

const route = useRoute();
const router = useRouter();

// 查询是否存在对应id
const checkId = async () => {
  const id = route.params.id;
  if (!id || id == "" || isArray(id) || startsWith(id, "resetPasswordEmail_"))
    return router.push({ name: "login" });
  const response = await checkResetPasswordIdApi(route.params.id as string);
  console.log(response);
};

// 重置密码参数
const resetPasswordParams = reactive<ResetPasswordParams>({
  code: (route.params.id as string) || "",
  newPassword: "",
});
const reEnterPassword = ref<string>("");

const result = ref<boolean | null>(null);
const posting = ref<boolean>(false);
const resetPassword = async () => {
  const flag = !some(resetPasswordParams, (value) => {
    // 检查是否为 null、undefined 或者 trim() 结果为空字符串
    return value == null || (typeof value === "string" && value.trim() === "");
  });
  if (reEnterPassword.value !== resetPasswordParams.newPassword) {
    ElMessage.error("两次输入的密码不一致");
  }
  if (flag) {
    posting.value = true;
    const response = await resetPasswordApi(resetPasswordParams);
    posting.value = false;
    console.log(response);
    result.value = response;
  }
};
onMounted(() => {
  checkId();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_result = _resolveComponent("el-result")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "logo" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("r.resetPassword")), 1)
      ]),
      (result.value == null)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("resetPass.newPassword")), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_input, {
                  modelValue: resetPasswordParams.newPassword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resetPasswordParams.newPassword) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("resetPass.reEnterPassword")), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_input, {
                  modelValue: reEnterPassword.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reEnterPassword).value = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "submit",
              color: "#f332e3",
              onClick: resetPassword,
              onKeyup: _withKeys(resetPassword, ["enter"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("resetPass.submit")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_link, {
              type: "primary",
              class: "returnLogin",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/login')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("resetPass.returnLogin")), 1)
              ]),
              _: 1
            })
          ])), [
            [_directive_loading, posting.value]
          ])
        : (result.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_el_result, {
                icon: "success",
                title: _ctx.$t('resetPass.success.title'),
                "sub-title": _ctx.$t('resetPass.success.tip')
              }, null, 8, ["title", "sub-title"])
            ]))
          : (!result.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_el_result, {
                  icon: "error",
                  title: _ctx.$t('resetPass.fail.title'),
                  "sub-title": _ctx.$t('resetPass.fail.tip')
                }, {
                  extra: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (result.value = null))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("resetPass.back")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["title", "sub-title"])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})